import { __extends } from "tslib";
import { PutBucketWebsiteRequest } from "../models/models_0";
import { deserializeAws_restXmlPutBucketWebsiteCommand, serializeAws_restXmlPutBucketWebsiteCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutBucketWebsiteCommand = /** @class */ (function (_super) {
    __extends(PutBucketWebsiteCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutBucketWebsiteCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutBucketWebsiteCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "PutBucketWebsiteCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: PutBucketWebsiteRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutBucketWebsiteCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutBucketWebsiteCommand(input, context);
    };
    PutBucketWebsiteCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutBucketWebsiteCommand(output, context);
    };
    return PutBucketWebsiteCommand;
}($Command));
export { PutBucketWebsiteCommand };
//# sourceMappingURL=PutBucketWebsiteCommand.js.map